import React, { FC, memo } from 'react';
import { DivThumbnail } from './styles';

type TProps = {
  src: string;
  onClick?: () => void;
  isReview?: boolean;
  className?: string;
};

const FnThumbnail: FC<TProps> = ({ src, onClick = null, isReview = true, className = '' }) => {
  return src ? (
    <DivThumbnail isReview={isReview} image={src} onClick={() => onClick && onClick()} className={className} />
  ) : (
    <DivThumbnail image="/assets/icons/file-image-light.svg" className={className} />
  );
};

export default memo(FnThumbnail);
